import * as React from 'react';
import { MILES_NEARYBY_COURTS } from 'constants/seo';
import type { GetCityVenuesByCitySlugQuery, GetVenuesByGeoQuery } from 'types/generated/server';
import CardVenue from 'components/cards/CardVenue';
import { getTitleLocationName } from './utils';

interface CityVenueListProps {
  venues: GetCityVenuesByCitySlugQuery['cities'][0]['venues'];
  nearbyVenues: Omit<GetVenuesByGeoQuery['venues'][0], 'city'>[];
  setListHoveredVenueId: (id: string | null) => void;
  listHoveredVenueId: string | null;
  city: GetCityVenuesByCitySlugQuery['cities'][0];
}

const CityVenueList: React.FC<CityVenueListProps> = ({
  venues,
  nearbyVenues,
  setListHoveredVenueId,
  listHoveredVenueId,
  city,
}) => {
  return (
    <div className="flex flex-col">
      {/* City venues */}
      <div className="px-4">
        {/* <h2 className="typography-product-subheading mb-4 text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
          Pickleball Courts in {getTitleLocationName(city)} ({venues.length} locations)
        </h2> */}
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          {venues.map((venue) => {
            if (!venue || !venue.id || !venue.title) {
              return null;
            }

            return (
              <div
                key={venue.id}
                onMouseEnter={() => setListHoveredVenueId(venue.id)}
                onMouseLeave={() => setListHoveredVenueId(null)}
                className={listHoveredVenueId === venue.id ? 'opacity-75 transition-opacity' : ''}
              >
                <CardVenue
                  {...venue}
                  totalCourtCount={venue.indoorCourtCount + venue.outdoorCourtCount}
                  imageUrl={venue.images[0]?.url}
                />
              </div>
            );
          })}
        </div>
      </div>

      {/* Nearby venues */}
      {!!nearbyVenues && !!nearbyVenues.length && (
        <div className="mt-16 border-t border-color-border-input-lightmode p-4 pt-16 dark:border-color-border-input-darkmode">
          <h2 className="typography-product-subheading mb-4 text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
            All Nearby Courts within {MILES_NEARYBY_COURTS} miles
          </h2>
          <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
            {nearbyVenues.map((venue) => {
              if (!venue || !venue.id || !venue.title) {
                return null;
              }

              return (
                <div
                  key={venue.id}
                  onMouseEnter={() => setListHoveredVenueId(venue.id)}
                  onMouseLeave={() => setListHoveredVenueId(null)}
                  className={listHoveredVenueId === venue.id ? 'opacity-75 transition-opacity' : ''}
                >
                  <CardVenue
                    {...venue}
                    totalCourtCount={venue.indoorCourtCount + venue.outdoorCourtCount}
                    imageUrl={venue.images[0]?.url}
                  />
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default CityVenueList;
